import React, { useContext } from 'react';
import {
  BreakdownColumn,
  BreakdownRow,
} from 'spw-programming-projects/program-summary/components/styles';
import { Box } from '@mui/material';
import {
  SmallCard,
  SmallCardTitle,
} from 'spw-components/project-details-tabs/program-summary/esa-single-page-summary/styles';
import {
  selectAltWorkpointsBreakdown,
  selectKeyData,
  selectTotalWorkpoints,
} from 'spw-redux/modules/program-summary/esa/selectors';
import { useSelector } from 'react-redux';
import { numberWithCommasOrDash } from 'spw-shared/utils';
import { selectAreaUnit } from 'spw-components/unit-conversion/selectors';
import { SpaceBetweenRow } from 'spw-shared/globalComponents/grid';
import InfoButton from 'spw-components/collab/info-button';
import { ProgramSummaryCardsContext } from '../summary-cards';

const WorkpointsCard = () => {
  const { showRsf, isRenderingForExport } = useContext(
    ProgramSummaryCardsContext
  );
  const areaUnit = useSelector(selectAreaUnit);
  const INFO_ITEMS = [
    {
      title: 'ALTERNATIVE WORKPOINTS',
      content: (
        <span>
          These seats are not double counted in any {areaUnit} or work seat
          totals. They have already been counted within the space categories
          that they are assigned to for their primary function.
          <br />
          <br />
          These alternative workpoints calculations show the impact to certain
          metrics when these seats are used for individual workspaces instead of
          their primary function.
        </span>
      ),
    },
  ];
  const keyData = useSelector(selectKeyData);
  const altWorkpointsBreakdown = useSelector(selectAltWorkpointsBreakdown);
  const totalWorkpoints = useSelector(selectTotalWorkpoints);

  return (
    <SmallCard $tall={showRsf} display="flex" flexDirection="column">
      <SpaceBetweenRow mb="12px" mt="-4px">
        <SmallCardTitle style={{ marginBottom: 0 }}>Workpoints</SmallCardTitle>
        {!isRenderingForExport && (
          <Box mr="-3px" mt="-2px">
            <InfoButton
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              providedInfoList={INFO_ITEMS}
            />
          </Box>
        )}
      </SpaceBetweenRow>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        flex={1}
      >
        <BreakdownRow>
          <BreakdownColumn item xs={8}>
            Work Seats
          </BreakdownColumn>
          <BreakdownColumn item xs={4} className="right">
            {numberWithCommasOrDash(keyData.workseats)}
          </BreakdownColumn>
        </BreakdownRow>
        <BreakdownRow className="last">
          <BreakdownColumn item xs={9}>
            Alternative Workpoints
          </BreakdownColumn>
          <BreakdownColumn item xs={3} className="right">
            {numberWithCommasOrDash(altWorkpointsBreakdown.all.seatsCount)}
          </BreakdownColumn>
        </BreakdownRow>
        <BreakdownRow>
          <BreakdownColumn item xs={9}>
            Total Workpoints
          </BreakdownColumn>
          <BreakdownColumn item xs={3} className="right">
            {numberWithCommasOrDash(totalWorkpoints)}
          </BreakdownColumn>
        </BreakdownRow>
      </Box>
    </SmallCard>
  );
};

export default WorkpointsCard;
